import { watch, computed } from 'vue';
import { AppModule } from '../../../../store/modules/appState';
import { PressModule } from '../../../../store/modules/pressState';
import { DboModule } from '../../../../store/modules/dboState';
import { MeetingModule } from '../../../../store/modules/meetingState';
import fastdom from 'fastdom';
import store from '../../../../store';

/**
 * Плагин устанавливающий глобальные настройки приложения
 */
export default {
    install() {

        store.registerModule('app', AppModule);

        // TODO move where used
        store.registerModule('press', PressModule);
        store.registerModule('dbo', DboModule);
        store.registerModule('meeting', MeetingModule);

        const measureOnResize = () => {
            const { innerHeight, innerWidth } = window;
            store.commit('app/SET_WINDOW_HEIGHT', innerHeight);
            store.commit('app/SET_WINDOW_WIDTH', innerWidth);
            store.commit('app/SET_IS_MOBILE', innerWidth <= 1000);
        };
        measureOnResize();

        const onResize = () => {
            fastdom.measure(measureOnResize);
        };

        const measureOnScroll = () => {
            const { scrollX, scrollY } = window;
            store.commit('app/SET_SCROLL_X', scrollX);
            store.commit('app/SET_SCROLL_Y', scrollY);
        };
        measureOnScroll();

        const onScroll = () => {
            fastdom.measure(measureOnScroll);
        };

        window.addEventListener('resize', onResize, { passive: true });
        screen?.orientation?.addEventListener('change', onResize, { passive: true });

        window.addEventListener('scroll', onScroll, { passive: true });

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { height, width } = entry.contentRect;
                store.commit('app/SET_PAGE_HEIGHT', height);
                store.commit('app/SET_PAGE_WIDTH', width);
            }
        });
        resizeObserver.observe(document.body);

        const h = computed(() => {
            return store.state.app.windowHeight;
        });

        watch(h, (val) => {
            fastdom.mutate(() => {
                document.documentElement.style.setProperty('--app-vh', val + 'px');
            });
        }, { immediate: true });

        watch(() => store.getters['app/mainTopOffsetScrolled'], (val) => {
            fastdom.mutate(() => {
                document.documentElement.style.scrollPaddingTop = val + 'px';
            });
        });
    }
}
